<doc>
  @desc:   布局 - 页脚组件
  @author:  
</doc>
<template>
  <div class="footer-wrapper" :class="minWidth?'footer-min-width':''">
    <div class="footer-content">
      <div class="footer-logo-box flex flex-align-center">
        <div class="logo-box">
          <router-link to="/">
              <span class="footer-logo"></span>
          </router-link>
        </div>
        <div class="footer-url">{{ theme == 5 ? 'kqbd.upgoal.com' : langConfig.txtLang[langConfig.curLang]['LOGO_TXT'] }}</div>
      </div>
      <div class="footer-menu-wrapper flex" v-if="policy">
        <div class="footer-menu-box flex flex-pack-justify">
          <dl>
            <dt>{{ langConfig.footer[langConfig.curLang]['FOOTBALL'] }}</dt>
            <dd><router-link to="/">{{ langConfig.footer[langConfig.curLang]['SCORE'] }}</router-link></dd>
            <dd><router-link to="/leagues/0/0">{{ langConfig.footer[langConfig.curLang]['LEAGUES'] }}</router-link></dd>
            <!-- <dd><a href="">{{ langConfig.footer[langConfig.curLang]['TRANSFER'] }}</a></dd>
            <dd><a href="">{{ langConfig.footer[langConfig.curLang]['PREDICTION'] }}</a></dd> -->
            <dd><router-link to="/news/0">{{ langConfig.footer[langConfig.curLang]['NEWS'] }}</router-link></dd>
          </dl>
          <dl>
            <dt>{{ langConfig.footer[langConfig.curLang]['ABOUT'] }}</dt>
            <dd><router-link to="/terms">{{ langConfig.footer[langConfig.curLang]['TERMS'] }}</router-link></dd>
            <dd><router-link to="/privacy">{{ langConfig.footer[langConfig.curLang]['PRIVACY'] }}</router-link></dd>
            <dd><a href="/sitemap.xml" target="_blank">{{ langConfig.footer[langConfig.curLang]['SITMAP'] }}</a></dd>
          </dl>
          <dl>
            <!-- <dt>{{ langConfig.footer[langConfig.curLang]['FOLLOW_US'] }}</dt>
            <dd class="flex flex-align-center"><i class="footer-menu-icon icon-font icon-facebook"></i><a href="">Facebook</a></dd>
            <dd class="flex flex-align-center"><i class="footer-menu-icon icon-font icon-instagram"></i><a href="">Instagram</a></dd>
            <dd class="flex flex-align-center"><i class="footer-menu-icon icon-font icon-threads"></i><a href="">Threads</a></dd> -->
          </dl>
        </div>
        <div class="footer-subscribe-box">
          <b>{{ langConfig.footer[langConfig.curLang]['SUB_TITLE'] }}</b>
          <p>{{ subEmailInfo }}</p>
          <el-tooltip popper-class="subPop" effect="dark" :disabled="subtipsS" :content="subtipsC" :value="!subtipsS" :manual=true placement="bottom-start">
            <div class="subscribe-box flex flex-align-center">
              <el-form ref="subForm">
                <el-input v-model="subForm.name" :placeholder="`${langConfig.footer[langConfig.curLang]['SUB_PLACEHOLDER']}`"></el-input>
              </el-form>
              <!-- <input type="text" class="placeholder" placeholder="Email Address" /> -->
              <button @click="subSubmit()">{{ langConfig.footer[langConfig.curLang]['SUB_BTN'] }}</button>
            </div>
          </el-tooltip>
        </div>
      </div>
      <div class="footer-copyright-box">
          <p>{{ langConfig.footer[langConfig.curLang]['NOTE'] }}</p>
          <p>{{ langConfig.footer[langConfig.curLang]['COPY_RIGHT'] }}</p>
      </div>
      <div class="back-to-top" v-show="isBack" @click="backTop">
        <i class="icon-font icon-arrow-up"></i>
      </div>
    </div>
    <div class="cookies-tips-wrapper" v-if="isCookieTips">
      <div class="cookies-tips-content">
        <i class="icon-font icon-close cookies-tips-close" @click="cookieTipClose()"></i>
        <p v-html="langConfig.footer[langConfig.curLang]['COOKIE_TIPS']"></p>
      </div>
    </div>
    <van-popup v-model="popShow"
    @closed="PopClose">
    <div class="sub-pop-wrapper" v-if="popShow">
      <div class="sub-pop-logo"></div>
      <div class="sub-step flex flex-v">
        <div class="sub-step-1 flex flex-v flex-pack-center">
          <div class="sub-rest-success"><img src="~@/assets/images/success-icon.svg" /></div>
          <div class="sub-title">{{ langConfig.footer[langConfig.curLang]['SUB_SUCCESS_TIPS'] }}</div>
          <div class="sub-success-btn" @click="PopClose">{{ langConfig.footer[langConfig.curLang]['CLOSE'] }}</div>
        </div>
      </div>
    </div>
    </van-popup>
  </div>
</template>

<script>
  import { getEmailSubscribe, getSubscribeEmailIntro } from '@/api/api';

  export default {
    props:{
      policy: {
        type: Boolean,
        default: true
      },
      minWidth: {
        type: Boolean,
        default: false
      },
    },

    data () {
      return {
        isBack: false,
        isCookieTips: false,
        subForm: {
          name: '',
        },
        subtipsS: true,
        subtipsC: '',
        popShow: false,
        subTimeOut: null,
        subEmailInfo: '',
        theme: 1,
      }
    },
    mounted() {
      if(typeof(window) != 'undefined'){
        const host = window.location.host;
        if(host.indexOf('kqbd') != -1){
          this.theme = 5;
        }
        this.cookieTips();
        window.addEventListener('scroll', this.handleScroll, false);
      }

      getSubscribeEmailIntro({
        userToken: '',
      }).then((res) => { 
        if(res.state == 200){
          this.subEmailInfo = res.data.content;
        }
          
      }).catch((res) => {
        console.error(res)
      })
    },
    methods: {
      // 滚动事件
      handleScroll() {
        let top = document.body.scrollTop || document.documentElement.scrollTop;
        if (top >= 280) {
          this.isBack = true
        } else {
          this.isBack = false
        }
      },
      // 回到顶部
      backTop() {
        let top = document.body.scrollTop || document.documentElement.scrollTop;
        const timeTop = setInterval(() => {
          top -= 50;
          document.body.scrollTop = top;
          document.documentElement.scrollTop = top;
          if (top <= 0) {
            clearInterval(timeTop);
          }
        }, 10);
      },
      // cookie提示
      cookieTips() {
        let _cookie = this.common.getCookie('cookietips');
				
				if(typeof(_cookie) != 'undefined' && _cookie != null){
          this.isCookieTips = false;
				}else{
          this.isCookieTips = true;
        }
      },
      // 关闭cookie提示
      cookieTipClose() {
        this.isCookieTips = false;
        this.common.setCookie('cookietips', true);
      },
      // 订阅显示
      subTipsShow(boo){
        this.subtipsS = boo;
        if(!boo){
          if(this.subTimeOut != null){
            clearTimeout(this.subTimeOut);
          }
          this.subTimeOut = setTimeout(() => {
            this.subTipsShow(true);
          }, 5000);
        }
      },
      // 订阅内容
      subTipsTxt(txt){
        this.subtipsC = txt;
      },
      // 订阅提交
      subSubmit(){
        let _reg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        let _email = this.subForm.name;

        if(_email == '' || !_reg.test(_email)){
          let _txt = this.langConfig.footer[this.langConfig.curLang]['SUB_ERRO_TIPS']
          this.subTipsTxt(_txt);
          this.subTipsShow(false);
          return;
        }

        let _param = {
          email: _email,
          userToken: '',
        }
        getEmailSubscribe(_param).then((res) => { //
          if(res.state == 400){ // 已订阅过
            this.subTipsTxt(res.msg);
            this.subTipsShow(false);
          }

          if(res.state == 200){
            this.popShow = true;
          }
          
        }).catch((res) => {
          console.error(res)
        })
      },
      // 关闭登录弹窗
      PopClose(){
        this.popShow = false;
        this.subForm.name = '';
      },
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll);
    },
  }
</script>

<style lang="less">
@import '~@/style/footer/footer.less';
</style>


// WEBPACK FOOTER //
// ./src/components/footer.vue